<template>
  <div class="article-frame">
    <div ref="content" class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('useful_link/pc_banner_terms.png')">
      <div class="content pos-relative">
        <go-to-top />
        <h1 class="main-title">
          利用規約
        </h1>
        <h2 class="update-time">
          最終更新日：2025年9月18日
        </h2>
        <h3 class="terms-title">
          利用規約と条件：
        </h3>

        <ol class="terms-list">
          <li>
            Ubet88にご登録のお客様は全員、本利用規約に同意する必要があります。本利用規約およびここで明示的に参照されている文書は、当サイトとお客様との間の完全な合意および理解を構成し、契約関係を規定します。当サイトをご利用いただく前に、本利用規約をよくお読みいただき、ご理解ください。お客様が本規約に同意されない場合は、当サイトをご利用にならないか、ご利用を継続しないようお願いいたします。また、当サイトのプライバシーポリシーについても十分にご理解いただいた上でのご利用を推奨いたします。
          </li>
          <li>
            本ページはUbet88の利用規約（以下「利用規約」）を構成しており、当サイトに登録される全てのお客様はこれに同意する必要があります。本規約およびここで明示的に参照される文書は、当サイトとお客様との間の完全な合意を構成し、契約関係を規定します。Ubet88をご利用いただく前に必ず本規約をよくお読みいただき、ご理解ください。これらの利用規約に同意いただけない場合は、当サイトをご利用にならないか、ご利用を継続されないようお願いいたします。
          </li>
          <li>
            Ubet88はライセンス番号15679に基づき、コモロ連合アンジュアン自治島政府の規制下で運営されています。当サイトは全ての規制遵守条件を満たし、賭博およびゲーム運営の法的権限を有しています。
          </li>
          <li>
            Ubet88は、Initial Singularity Limitedによって所有および運営されております。<br>
            登録番号: 15679 登録住所: Hamchako, Mutsamudu, Autonomous Island of Anjouan Union of Comoros.
          </li>
          <li>
            これらの利用規約に同意し、当サイトにアカウント（以下「アカウント」といいます）を登録することにより、お客様は以下を表明し、保証するものとします。
            <ol class="list-type-lower-alpha">
              <li>
                ご自身の名前でアカウントを登録すること。
              </li>
              <li>
                すべてのアカウント情報（アカウント番号・パスワードを含む）および、当サイトを通じてアカウントにアクセスするその他の手段については、お客様ご自身が単独で責任を負うこと。不正アクセスやアカウント侵害の被害が疑われる場合は、直ちに当サイトへ連絡し、アカウントおよび残高への不正利用を防止するための適切な措置を講じること。
              </li>
              <li>
                お客様が満20歳以上であること。20歳未満の方はカジノを利用することが禁じられており、違反が確認された場合、アカウントは直ちに閉鎖されること。
              </li>
              <li>
                当サイトでは、お一人につき1つのアカウントのみ作成できること。複数アカウントの開設、またはその試みが確認された場合、当サイトの裁量により該当アカウントの一部または全部をブロックまたは終了し、全てのベット（決済済・未決済を問わず）をキャンセルし、出金可能な資金を没収または返金する場合があること。
              </li>
              <li>
                お客様は、他者の代理ではなく、自身の立場において、かつ自己の娯楽および楽しみの目的に限り当サイトを利用すること。
              </li>
              <li>
                一部の法域（司法管轄地域）では、当サイトへのアクセスまたは利用が違法とみなされる場合があることを理解すること。
              </li>
            </ol>
          </li>
          <li>
            Ubet88は、適用される法律・規制およびその他の要件を遵守することを含め、本利用規約をいつでも変更する権利を有します。<br>
            利用規約に重大な変更があった場合には、当サイト上に通知を掲載いたします。お客様が改訂後の利用規約に同意されない場合、当サイトはお客様のアカウントを閉鎖いたします。その際、有効なアカウント残高を出金する場合は、カスタマーサービスまでご連絡いただく必要があります。
          </li>
          <li>
            アカウントを作成するには、携帯電話番号、パスワード等の個人情報を入力し、登録完了後に氏名、生年月日、住所等の情報を追加で入力していただく必要があります。
          </li>
          <li>
            アカウントに登録する氏名および住所は、提出いただく身分証明書および関連する確認書類と一致している必要があります。また、身分証明書に記載された住所は、住所確認書類と一致していなければなりません。当サイトは本人確認のため、いつでもお客様に対して本人確認書類（パスポート、身分証明書、住所確認書類、有効期限内で利用可能なクレジットカード等を含む）の提出を求める権利を有します。提出が行われない場合、当サイトはお客様のアカウントを一時的に閉鎖する権利を有します。
          </li>
          <li>
            ご登録の際には正確な個人情報を入力していただき、登録情報に変更が生じた場合には速やかに更新していただく必要があります。これらを怠った場合、アカウントの閉鎖、利用制限、入金（ボーナスを含む）の無効化などが行われる場合があります。当サイトは理由の如何を問わず、いかなる人物に対しても口座開設を拒否する権利を留保します。
          </li>
          <li>
            VPNやプロキシサーバーなどを利用して実際の位置情報を隠す行為は禁止されています。お客様が制限地域から当サイトにアクセスしていると当サイトが判断した場合、当サイトは事前通知を行うことなく、直ちにアカウントを閉鎖する権利を有します。<br>
            禁止地域：米国およびその属領、マカオ、スイス、アイルランド、シンガポール、ハンガリー、ミャンマー、ルーマニア、ベルギー、デンマーク、フィンランド、ドイツ、イラン、イラク、イタリア、ミクロネシア、ノルウェー、ポーランド、サウジアラビア、オランダ、プエルトリコ、英国、フランス、香港、台湾、北朝鮮、イスラエル、キプロス、エストニア、フィリピン、トルコ、スペイン、ブルガリア、アンティグア・バーブーダ、キュラソー、その他法律または地域の条例によりオンラインカジノが禁止されている国・地域。<br>
            これらの国・地域に居住するお客様は、Ubet88をご利用いただくことはできません。
          </li>
          <li>
            全てのお客様について、IPアドレスまたはデバイスごとに登録できるアカウントは1つのみとします。また、1世帯につき1アカウントに限られます。当サイトが、お客様が複数のアカウントを所持していると判断した場合、当サイトの裁量により、重複したアカウントをブロックまたは閉鎖し、該当アカウントにおけるすべての賭け（決済済みのものを含む）を無効とすることがあります。さらに、出金可能な資金についても没収または返金の対象となります。
          </li>
          <li>
            アカウント情報は登録プロセスの一部であり、お客様は当サイトにログインするためにアカウント名とパスワードを選択する必要があります。ログイン情報のセキュリティを保護する責任はお客様にあり、ログイン情報を第三者に開示してはなりません。当サイトは、ログイン情報の第三者への開示（意図的か非意図的か、積極的か受動的かを問いません）によって発生するアカウントの不正利用について、一切の責任を負いません。お客様のログイン情報を用いて行われたすべての行為は、お客様ご自身の行為とみなされ、その結果生じるすべての責任はお客様が負うものとします。お客様のログイン情報が第三者に知られた場合は、直ちに当サイトへ通知し、速やかにログイン情報を変更するものとします。
          </li>
          <li>
            当サイトは、理由の如何を問わず、いつでもお客様の身元を確認し、関連書類の提出を求める権利を有します。これには、法律で許可されている身元調査、信用調査、個人履歴調査が含まれますが、これらに限定されるものではありません。調査の基準は状況に応じて異なりますが、氏名、住所、年齢、職業、金融取引（財務状況や資金源など）を含む登録情報、またはお客様のゲーム活動記録等の確認が行われる場合があります。Ubet88は、調査が進行中であることをお客様に通知する義務を負いません。また、調査には、認可を受けた信用照会機関、身元確認サービス、不正防止機関など、調査の実施に必要な第三者企業を利用する場合があります。調査の結果が否定的または不確定であった場合、Ubet88は独自の裁量により、お客様のアカウントを閉鎖し、すべての決済済みの賭けをキャンセルし、残高を保留することができます。なお、すべての個人情報は当サイトのプライバシーポリシーに従い取り扱われます。
          </li>
          <li>
            マネーロンダリングを防止するため、当サイトではすべての支払い取引を監視しています。Ubet88および規制・監督機関は、犯罪防止を目的として、すべての取引について監視または調査を要求する場合があります。Ubet88は、疑わしい取引を関連当局に報告いたします。さらに、当サイトのゲームに関連して不審な行為を発見した場合、直ちに関連当局に報告し、適用されるマネーロンダリング防止法およびテロ資金供与対策法に従い、アカウントの凍結または閉鎖、決済済みの賭けのキャンセル、および／または口座残高の保留を行う場合があります。
          </li>
          <li>
            お客様はいつでもアカウントにログインし、入金・出金・報酬記録・ゲーム記録などのアカウント履歴を閲覧することができます。エラーを発見した場合には、調査および修正が可能となるよう、直ちにサポートへ連絡する必要があります。
          </li>
          <li>
            クレジット、ボーナス、またはその他の資金が誤ってアカウントに入金された場合、お客様はメールまたはチャットを通じて直ちにUbet88へ報告しなければなりません。誤って入金されたすべての金額はUbet88の所有物となり、お客様は自身のアカウントから速やかに返金する義務を負います。お客様が誤入金された資金を出金した場合、お客様はUbet88の清算債務者とみなされ、出金した金額を直ちに返済しなければならず、また、誤って入金されたポイント、ボーナス、またはその他の資金を使用して行われた賭けはすべて無効となります。
          </li>
          <li>
            12か月間連続して取引活動がない場合、アカウントは休止状態とみなされます。アカウントが休止状態となる少なくとも1か月前に、Ubet88はお客様にメールで通知を行います。お客様は、アカウントにログインすることで休止状態を解除し、アカウントを再開することができます。アカウントが休止状態とみなされた後、Ubet88がお客様と連絡を取ることができなかった場合、Ubet88はアカウント残高の5％または月額150円のいずれか高い方を管理手数料として徴収します。休止アカウントの管理手数料により残高がゼロになることがあります。手数料の返金を求める場合は、休止期間中の健康上の不調やその他の正当な理由を証明する書類を提出する必要があります。アカウント残高の額にかかわらず利子は発生しません。したがって、お客様はUbet88を金融機関と見なすことはできません。
          </li>
          <li>
            Ubet88は、お客様による不正行為や共謀行為を厳格に禁止します。詐欺、または共謀行為が発生したと合理的に判断された場合、当サイトはその結果として行われた賭けをキャンセルし、またはお客様のアカウント内のすべての資金を没収のうえ閉鎖する権利を留保します。他のお客様が詐欺または共謀行為によって不正な利益を得ていると疑う合理的な理由がある場合は、お客様はメールまたはチャットを通じてUbet88へ報告しなければなりません。
          </li>
          <li>
            他のお客様のアカウントへ資金を送金する行為、またはその逆に資金を受け取る行為は禁止されています。
          </li>
          <li>
            お客様は、いかなる方法であっても当サイトに不正に侵入したり、当サイトのコードを改変したりしないこと、また当サイトの脆弱性を悪意をもって利用しないこと、さらにお客様または第三者が当サイトを利用する際に、ボット、自動化プログラム、機械的または電子的な機器、その他の不正なツールを使用しないことに同意したものとみなされます。当サイトが、上記の機器またはお客様に不当な利益を与える目的で設計された外部リソースが利用されたと合理的に判断した場合、これらの手段によって行われたすべての賭けは無効とみなされます。また、当サイトは独自の裁量により、調査中のアカウントを一時的に凍結または閉鎖する場合があります。当サイトでは、上記の機器の使用は詐欺に該当するとみなし、この場合、残高を返金することなくアカウントを閉鎖する権利を留保します。
          </li>
          <li>
            お客様は、いかなる方法であっても当サイトに不正に侵入したり、当サイトのコードを改変したりしないこと、また当サイトの脆弱性を悪意をもって利用しないこと、さらにお客様または第三者が当サイトを利用する際に、ボット、自動化プログラム、機械的または電子的な機器、その他の不正なツールを使用しないことに同意したものとみなされます。当サイトが、上記の機器またはお客様に不当な利益を与える目的で設計された外部リソースが利用されたと合理的に判断した場合、これらの手段によって行われたすべての賭けは無効とみなされます。また、当サイトは独自の裁量により、調査中のアカウントを一時的に凍結または閉鎖する場合があります。当サイトでは、上記の機器の使用は詐欺に該当するとみなし、この場合、残高を返金することなくアカウントを閉鎖する権利を留保します。
          </li>
          <li>
            お客様は、ご自身のアカウントからの入出金に際し、正当な金融機関によって発行された本人名義の有効なクレジットカードおよび口座、またはその他の正規の支払い方法のみを使用することに同意したものとみなされます。当サイトが、お客様の支払い名義がご本人のものではないと判断した場合、当サイトはお客様のアカウントを閉鎖し、すべての賞金を無効とし、さらに当該カードの利用を禁止する権利を留保します。
          </li>
          <li>
            お客様は、ご自身のアカウントから資金を出金する際、任意の金額を入金し、KYC本人確認を完了する必要があることに同意するものとします。最低入金額については、当サイト内のお客様アカウントの「入金」ページで確認することができます。
          </li>
          <li>
            Ubet88は、出金処理に伴い発生する合理的な手数料を請求する権利を留保します。さらに、当サイトの管理範囲外で発生する外部銀行手数料が追加でかかる場合があり、これらの出金手数料はお客様のアカウントの「出金」ページに表示されます。
          </li>
          <li>
            不正な手段で取得された資金は違法とみなされます。適用される法律に従い、Ubet88は可能な限り資金移動にお客様と同一のキャッシュフローを使用します。入出金は登録されたアカウント所有者本人の名義でのみ行うことができます。Ubet88は、必要に応じて外部との接触を強制的に遮断する管理を行うか、またはお客様に特定の支払方法での出金を求め、出金を取り消す権利を有します。
          </li>
          <li>
            すべての出金は、原則として入金時にお客様が選択した同一の決済方法を通じて行う必要があります。ただし、当サイトが別途認める場合、または当該方法での処理が不可能な場合を除きます。複数の決済方法で入金が行われた場合、当サイトはお客様の出金をそれぞれの入金方法に応じて分割し、当サイトの裁量により処理する権利を有します。これらの処理は、マネーロンダリング防止に関する規制および方針に従って行われます。
          </li>
          <li>
            お客様がクレジットカードまたはデビットカードで入金する場合、当サイトはその裁量により、セキュリティコード（CVV）に加え、カード番号の最初の6桁および最後の4桁が確認できるカード両面の画像を提出するよう求める場合があります。
          </li>
          <li>
            アカウントから資金を出金するには、お客様はゲーム内で少なくとも入金額の2倍に相当する金額を賭ける必要があります。Ubet88は独自の裁量により、賭け金が不十分であると判断した場合、出金申請の支払いを拒否し、特定の条件下においてお客様に対し、追加の賭け金を要求する権利を有します。
          </li>
          <li>
            無料ベットまたはボーナスは、イベントやプロモーションの一環としてお客様のアカウントに付与される場合があります。これらの無料ベットやボーナスは当サイト内で利用する必要があり、そのまま出金することはできません。各イベントやプロモーションに応じて、これらの無料ベットやボーナスは、当該イベントまたはプロモーションの特定の利用規約を満たすことで、リアルマネーに変換される場合があります。すべてのイベントまたはプロモーションには、ボーナスルールおよび利用規約が適用されます。詳細については、ボーナスルールおよび利用規約をご確認ください。
          </li>
          <li>
            お客様によるアカウントへの入出金は、金融機関または決済サービス機関を通じて行われます。入出金の手順、利用条件、可用性、手数料、処理時間は、利用される金融機関または決済サービスプロバイダーによって異なる場合があります。
          </li>
          <li>
            お客様は入金を行う際、各入金申請時に当社が指定する口座へ振り込みを行うものとします。 過去の入金履歴等を参照し、申請時に指定されていない口座へ誤って振り込みを行った場合、当該資金の着金確認、資金の追跡、返金対応ができない可能性があります。<br>この場合、当該資金の未反映、紛失、返金不能等に関して、当社は一切の責任を負いません。
          </li>
          <li>
            当サイトでは掛売りは認められません。アカウントに十分な資金を維持し、その範囲内で賭けを行う責任はお客様にあります。口座残高が不十分な場合に行われた賭け取引は無効となります。お客様のアカウント残高がすべての賭けをカバーするのに不足している場合、当サイトは不用意に行われた、または誤って受け入れられた賭けをキャンセルする権利を留保します。さらに、清算機関による入金キャンセルによりアカウントの資金が不足した場合、Ubet88は受付済みのすべての賭けを遡及的に無効とし、当該賭けからお客様に支払われた資金を払い戻す権利を留保します。
          </li>
          <li>
            KYC認証が完了している場合、出金承認は原則として数分程度で完了します。ただし、ゲームプロバイダーによるチェックが必要な場合や、提携決済会社のメンテナンス、またはお客様の受取先口座のメンテナンス等により、処理に時間を要する場合があります。
          </li>
          <li>
            お客様のアカウントへの入金は、必ずお客様のゲームプレイに対応している必要があります。当サイトがアカウントの不正利用を確認した場合、Ubet88は独自の裁量により、お客様のアカウントを閉鎖し、アカウント内の報酬および残高を没収する権利を有します。これらの不正利用には、出金申請を行う前に入金額を賭けていなかった場合や、その他不正な利用が含まれますが、これに限定されません。
          </li>
          <li>
            当サイトは、いつでも取引記録およびゲーム記録を閲覧する権利を有します。再調査の結果、不正行為を用いてゲームをプレイしていたと判断された場合、当サイトは独自の裁量により、当該お客様に対して付与された報酬、ボーナス、リベートを取り消す権利を留保します。
          </li>
          <li>
            お客様が実際のボーナス額を超えるボーナスを獲得する目的でイベントまたはプロモーションにおいて不正行為（以下の内容を含む）を行った場合、当サイトは直ちにお客様を今後のすべてのイベントおよびプロモーションからの参加資格を剥奪します。
          </li>
          <li>
            以下の行為が確認された場合、当サイトは規約違反とみなし、必要に応じて措置を講じます。
            <ol class="list-type-lower-alpha">
              <li>
                第三者への情報の不正な開示
              </li>
              <li>
                バグ、脆弱性、ハッキング、コンピューター攻撃、その他の不正行為（詐欺を含む）、または自動化されたゲーム（ボット）を悪用して不当な賭けを行うこと
              </li>
              <li>
                不正にコピーまたは利用されたクレジットカードまたはデビットカードを使用して賭けを行うこと
              </li>
              <li>
                ゲーム内において、直接または間接的に他のプレイヤーと共謀を図ること
              </li>
              <li>当サイトのイベントまたはプロモーションを濫用すること</li>
            </ol>
            当サイトでは、上記の行為を厳格に禁止します。万が一、他のプレイヤーとの共謀行為が確認された場合、当サイトは適切な措置を講じる権利を留保し、お客様および他のプレイヤーが被った損失については一切の責任を負いません。<br>
            また、お客様が他のプレイヤーによる共謀行為、詐欺などの犯罪行為を確認された場合には、直ちに当サイトまでご連絡ください。<br>
            さらに、お客様が当サイトのサービスやソフトウェアを悪用していることが判明した場合、Ubet88はお客様のアカウントをブロックし、アカウント内の資金を没収する権利を有します。出金条件を満たすためにゲームモードを改変し、ゲーム構造を悪用しようとした場合、または悪意をもって利用した場合には、当サイトはすべてのボーナスおよび利益を没収するか、またはお客様のアカウントを直接閉鎖する権利を有します。
          </li>
          <li>
            お客様は、当サイトで提供されるサービスが娯楽目的のみに限られることに同意したものとみなされます。サービスの利用は強制ではなく、お客様ご自身の判断により利用するか否かを選択・決定することができます。したがって、当サイトにアクセスするお客様は、自己の責任においてゲームをプレイする必要があります。お客様は、当サイトにアクセスする際、ご自身の名義で娯楽目的に限り当サイトが提供するサービスを利用し、楽しむことに同意したものとみなされます。当サイトは、お客様が上記以外の方法でサービスを利用することを固く禁止します。
          </li>
          <li>
            Ubet88は、お客様に事前の通知を行うことなく、独自の裁量により、当サイトおよび／または一部のゲームまたはマーケット製品を一時停止、変更、削除、追加する権利、さらに一時的または永久的に利用停止措置を講じる権利を留保します。これによりお客様が被ったいかなる損失についても、当サイトは一切の責任を負いません。
          </li>
          <li>
            いかなる理由であっても、承認済みのゲームラウンドが中断または終了した場合、すべてのお客様の取引は正確に記録され、ゲームが再開される際には未完了のゲームラウンドは途中から再開されます。万一、回復が不可能であった場合、Ubet88は当該ゲームラウンドを削除し、お客様のアカウントに賭け金を返金します。
          </li>
          <li>
            Ubet88が制御不能状態に陥った場合、例として予期しない技術的問題や第三者事業者による技術的問題が発生した場合、Ubet88は賭けをキャンセルまたは返金する場合があります。また、お客様は、コンピューターまたはモバイルデバイスの性能やネットワーク接続が当サイトのパフォーマンスおよび操作に影響を与える可能性があることに同意するものとします。Ubet88は、お客様の機器、ネットワーク接続、またはサードパーティのプロバイダーによって引き起こされる不具合や問題について、一切の責任を負いません。これには、ゲームをプレイできない場合や、特定のゲームに関連する情報を表示または受信できない場合などが含まれます。
          </li>
          <li>
            Ubet88は、当サイトが完全かつエラーなく機能すること、お客様が当サイトおよび当サイトが提供するゲームに中断なくアクセスできること、また当サイトおよびゲームが特定の目的に適合することについて、明示的か黙示的かを問わず一切保証しないものとします。
          </li>
          <li>
            当サイトに関するすべての知的財産権（IP権）は、Ubet88またはサードパーティのソフトウェア事業者に帰属します。当サイトを利用することは、お客様が当サイトまたはソフトウェアプロバイダーの知的財産権を所有することを意味するものではありません。知的財産権には、特許、著作権、意匠権、商標、データベース権およびそれらの応用が含まれます。また、著作者人格権、専有技術、企業秘密、機密情報、ドメイン名、URL、商号およびその他すべての知的財産権（およびそれに関連するライセンス）も含まれます。これらには、登録の有無や登録可能性、特定の国や地域、または世界の他の場所に居住しているかどうかを問わず適用されますが、これらに限定されるものではありません。
          </li>
          <li>
            お客様は、適用される法律の範囲内において、以下の行為を行ってはなりません。
            <ol class="list-type-lower-alpha">
              <li>
                ソフトウェアおよび／または当サイトのコピー、配布、公開、リバースエンジニアリング、逆コンパイル、逆アセンブル、変更、変換、翻訳、その他いかなる方法によるデコード、またはソースコードを取得して二次的著作物を作成しようとする行為
              </li>
              <li>
                ソフトウェアおよび／または当サイト、またはその一部から著作権、所有権、その他の権利表示を削除する行為
              </li>
              <li>
                ソフトウェアの販売、譲渡、サブライセンス、頒布またはリースを行う行為
              </li>
              <li>
                コンピュータネットワークその他の手段を通じてソフトウェアを第三者に提供する行為
              </li>
              <li>
                ソフトウェアを物理的または電子的な方法でいかなる国へも輸出する行為
              </li>
              <li>
                適用される法律または規制で禁止されている方法によるソフトウェアの使用
              </li>
              <li>
                知的財産権に損害を与える、または損害を与える可能性のある行為、あるいはInitial Singularity Limited社、その従業員、取締役、役員、コンサルタントのイメージや評判を傷つける行為
              </li>
              <li>
                本規約において明示的に許可されていない方法で、ソフトウェアおよび／または当サイト、またはその一部を使用する行為
              </li>
            </ol>
          </li>
          <li>
            お客様は、当サイトまたはゲーム内で使用するプレイヤー名や画像（プレイヤーのアカウント等を含む）が、第三者の知的財産権、プライバシー権、その他の権利を侵害せず、かつ他人に不快感を与えないものであることを保証するものとします。また、お客様は、当サイトのプライバシーポリシーの条項に従い、当サイトまたはゲームに関連するあらゆる目的で使用するために、これらの名前や画像について、取消不能かつ譲渡可能で、ロイヤルティフリー、さらにサブライセンス可能な使用権をUbet88に付与するものとします。
          </li>
          <li>
            お客様が当サイトのサービスに関してご意見をお持ちの場合は、当サイトの指示に従ってカスタマーサービスチームへご連絡いただくか、{{ supportEmail }} 宛にメールを送信してください。
            特定のゲームに関するご意見やお問い合わせは、問題が発生してから7営業日以内に行う必要があります。これには、支払い、アカウントの停止、ボーナスの計算に関する事項も含まれますが、これらに限定されるものではありません。<br>
            その他の事項に関しては、問題発生から1か月以内にご連絡いただく必要があります。ご意見やお問い合わせはカスタマーサービスチームが対応いたします。<br>
            カスタマーサービススタッフが直ちに解決できない場合は、Ubet88の内部担当者が対応し、お客様には現在のお問い合わせ状況を適切にお知らせいたします。<br>
            当サイトは、通常14営業日以内に問題を解決するため最善を尽くします。
          </li>
          <li>
            お客様は、カスタマーサービスにご連絡いただくことで、いつでもアカウントを閉鎖し、利用可能な残高を出金することができます。<br>
            お客様のアカウント残高がマイナスの場合は、直ちに当サイトに対して不足額のお支払い手続きを行う必要があります。アカウントは、残高が全額精算された場合にのみ閉鎖されます。<br>
            アカウント閉鎖時に未決済の賭け金が残っている場合、それらは有効とみなされます（ただし、当サイトの利用規約に基づきキャンセルまたは無効化される場合を除きます）。この場合、お客様は当サイトにご連絡いただくことで、当該賭けから得られた賞金を回収することができます。<br>
            （ただし、当サイトが利用規約に基づき賞金の全部または一部を留保する権利を行使する場合を除きます。）
          </li>
          <li>
            当サイトは、以下の事由が発生した場合、説明を行うことなく、お客様のアカウントを一時停止または終了し、お客様が行った賭けを取り消し、アカウントから賞金を削除し、さらに当サイトが適切と判断するその他の措置を講じる権利を留保します。
            <ol class="list-type-lower-alpha">
              <li>
                当サイトとのビジネス関係を継続することが、当サイトのライセンスおよび規制上の義務、またはサービスに悪影響を与える可能性があると当サイトが判断した場合
              </li>
              <li>
                お客様が当サイトにおいて違法または詐欺行為に該当する行為を行った場合
              </li>
              <li>
                お客様がギャンブル禁止地域に居住している、または禁止地域において当サイトのゲームを利用した場合
              </li>
              <li>
                お客様が本利用規約に違反した場合
              </li>
              <li>
                法律または当サイトの第三者ライセンス許諾者により、当サイトに措置を講じるよう命じられた場合
              </li>
            </ol>
            本規約の第12条に記載されている理由により当サイトがお客様のアカウントを終了する場合、お客様が本規約および関連規則を遵守している限り、当サイトはお客様がその時点で保有している正当なアカウント残高を返金します。<br>
            法律で認められる最大限の範囲において、当サイトはお客様に対して一切の責任を負いません。<br>
            なお、上記の内容は、必要に応じて当サイトが適切な状況においてお客様に対して法的措置を講じる権利を制限するものではありません。
          </li>
          <li>
            いかなる場所においても、Ubet88に関わるすべての者に対して、攻撃的、誹謗中傷、侮辱的な発言、またはその他不快な内容の発言や行動を行った場合、当サイトの判断によりお客様のアカウントを停止または制限することがあります。また、その場合には、以降のチャットやメールへの対応を中止することがあります。
          </li>
          <li>
            お客様が当サイトを通じて賞金を獲得された場合、Ubet88は宣伝活動およびプロモーションを目的として、お客様のアカウント名を使用することについてご同意いただいたものとみなします。
          </li>
          <li>
            Ubet88は、マネーロンダリング等を防止するため、必要に応じてお客様に「収入を証明する書類」の提出を求める場合があります。
          </li>
          <li>
            お客様は、自己が管理する仮想通貨ウォレットから、当サイトが指定するアドレスへ資金を送金することにより、当サービスのアカウントに入金することができます。<br>
            誤った仮想通貨、誤ったネットワーク、または誤ったウォレットアドレスに送金された資金については、回収が不可能となる場合があり、当サイトは一切の責任を負いません。送金を行う前に、正確な通貨・ネットワーク・アドレスであることを必ずご確認ください。
          </li>
          <li>
            原則として当サービスにおいて仮想通貨間の交換を行うことはできません。ただし、当サイトが別途認めた場合、または実行が不可能な場合を除きます。なお、この規定はマネーロンダリング防止に関する国際基準の要件に基づきます。
          </li>
          <li>
            仮想通貨による入金に必要な情報は、当サイトの「入金」ページにて提供されます。送金の際は、当該情報を十分にご確認のうえ、お手続きください。
          </li>
          <li>
            当サイトは、仮想通貨を用いた入出金を希望するお客様に対し、追加の本人確認（KYC）およびセキュリティ審査を行う権利を有します。疑わしい取引が確認された場合、当サイトはアカウントを一時停止し、追加のデューデリジェンスを求めることができます。
          </li>
          <li>
            当サイトが本人確認（KYC）およびセキュリティ審査に関する追加情報の提供をお客様に依頼した場合、お客様は当該通知から48時間以内に対応する義務を負うものとします。
            この期限内に対応が行われない場合、当サイトはお客様のアカウントを一時的に停止する、または出金を保留する権利を有します。
          </li>
        </ol>
      </div>
    <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  name: 'TermsBlue',
  components: {
    goToTop
  },
  data() {
    return {
      content: false,
      isHiddenBox: false,
      isOpen: false,
      isHiddenButton: false
    }
  },
  computed: {
    footerIframe() {
      return 'https://katsuwin.info/iframe/term-of-service'
    },
    supportEmail() {
      return process.env.VUE_APP_SUPPORT_EMAIL
    }
  },
  created() {
  },
  methods: {

  }
}
</script>
